import { useState, useCallback } from "react";

export default function useAppLoading() {
  const [husibuechLoading, setHusibuechLoading] = useState(false);
  const [sonderEventLoading, setSonderEventLoading] = useState(false);
  const [eventManagerLoading, setEventManagerLoading] = useState(false);
  const [bszFinderLoading, setBszFinderLoading] = useState(false);
  const [bszPlannerLoading, setBszPlannerLoading] = useState(false);
  const [askomaLoading, setAskomaLoading] = useState(false);

  // ✅ optional helpers (very useful)
  const resetAllLoading = useCallback(() => {
    setHusibuechLoading(false);
    setSonderEventLoading(false);
    setEventManagerLoading(false);
    setBszFinderLoading(false);
    setBszPlannerLoading(false);
    setAskomaLoading(false);
  }, []);

  return {
    husibuechLoading,
    setHusibuechLoading,

    sonderEventLoading,
    setSonderEventLoading,

    eventManagerLoading,
    setEventManagerLoading,

    bszFinderLoading,
    setBszFinderLoading,

    bszPlannerLoading,
    setBszPlannerLoading,

    askomaLoading,
    setAskomaLoading,

    resetAllLoading,
  };
}
